import billingStructure from '../sub/billing';

export default [
    {
        key: 'settings.users.main',
        type: 'route',
        route: 'app.users.index',
        right: 'users::list',
        children: [
            {
                key: 'settings.users.details',
                type: 'route',
                route: 'app.users.details',
                showInNavigation: false,
                hideTabNav: true,
                right: 'users::view',
                children: [
                    {
                        key: 'settings.users.edit',
                        showInNavigation: false,
                        hideTabNav: true,
                        type: 'route',
                        route: 'app.users.edit',
                        right: 'users::edit'
                    }
                ]
            }
        ]
    },
    {
        key: 'settings.billing.main',
        type: 'placeholder',
        children: billingStructure
    },
    {
        key: 'settings.job-log',
        type: 'route',
        route: 'app.queue.index',
        right: 'queue::list'
    },
    {
        key: 'settings.action-log',
        type: 'route',
        route: 'app.action_log.list',
        right: 'action-log::list'
    },
    {
        key: 'settings.blacklist',
        type: 'route',
        route: 'app.settings.blacklists',
        right: 'companies::edit'
    },
    {
        key: 'settings.seatplans.main',
        type: 'route',
        route: 'app.seatplans.index',
        right: 'seatplans::list',
        children: [
            {
                key: 'settings.seatplans.create',
                type: 'route',
                showInNavigation: false,
                route: 'app.seatplans.index',
                right: 'seatplans::create',
                children: []
            },
        ]
    },
    {
        key: 'settings.media',
        type: 'route',
        route: 'app.media.index',
        right: 'addressbook_categories::list'
    },
    {
        key: 'settings.custom_defaults.main',
        type: 'placeholder',
        children: [
            {
                key: 'settings.custom_defaults.guestlists',
                type: 'route',
                route: 'app.settings.custom-fields.guestlist',
                right: 'companies::edit'
            },
            {
                key: 'settings.custom_defaults.contacts',
                type: 'route',
                route: 'app.settings.custom-fields.contact',
                right: 'companies::edit'
            },
            {
                key: 'settings.notifications',
                type: 'route',
                route: 'app.settings.notifications',
                right: 'companies::edit'
            },
            {
                key: 'settings.custom_defaults.bo-objects.main',
                type: 'route',
                route: 'app.bo.objects.index',
                right: 'bookable_objects::object_list',
                children: [
                    {
                        key: 'settings.custom_defaults.bo-objects.create',
                        type: 'route',
                        route: 'app.bo.objects.create',
                        right: 'bookable_objects::object_create',
                        showInNavigation: false,
                        hideTabNav: true
                    },
                    {
                        key: 'settings.custom_defaults.bo-objects.details.main',
                        type: 'placeholder',
                        showInNavigation: false,
                        children: [
                            {
                                key: 'settings.custom_defaults.bo-objects.details.details',
                                type: 'route',
                                route: 'app.bo.objects.details',
                                right: 'bookable_objects::object_view',
                                showParentTabs: true
                            },
                            {
                                key: 'settings.custom_defaults.bo-objects.details.options.main',
                                type: 'route',
                                route: 'app.bo.options.index',
                                right: 'bookable_objects::option_list',
                                showParentTabs: true,
                                children: [
                                    {
                                        key: 'settings.custom_defaults.bo-objects.details.options.create',
                                        type: 'route',
                                        route: 'app.bo.options.create',
                                        right: 'bookable_objects::option_create',
                                        showInNavigation: false,
                                        hideTabNav: true
                                    },
                                    {
                                        key: 'settings.custom_defaults.bo-objects.details.options.details',
                                        type: 'route',
                                        route: 'app.bo.options.details',
                                        right: 'bookable_objects::option_view',
                                        showInNavigation: false,
                                        children: [
                                            {
                                                key: 'settings.custom_defaults.bo-objects.details.options.edit',
                                                type: 'route',
                                                route: 'app.bo.options.edit',
                                                right: 'bookable_objects::option_edit',
                                                showInNavigation: false
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                key: 'settings.custom_defaults.bo-objects.details.edit',
                                type: 'route',
                                route: 'app.bo.objects.edit',
                                right: 'bookable_objects::object_edit',
                                showInNavigation: false,
                                hideTabNav: true
                            },
                            {
                                key: 'settings.custom_defaults.bo-objects.details.edit',
                                type: 'route',
                                route: 'app.bo.objects.edit',
                                right: 'bookable_objects::object_edit',
                                showInNavigation: false,
                                hideTabNav: true
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        key: 'settings.exports',
        type: 'route',
        route: 'app.mo-exports.index',
        right: 'exports::list'
    },
    {
        key: 'settings.logout',
        type: 'route',
        showInNavigation: false,
        route: 'app.logout',
        right: null
    },
    {
        key: 'settings.profile',
        type: 'route',
        route: 'app.settings.profile-edit',
        right: null,
        showInNavigation: false,
        hideTabNav: true
    },
]



// WEBPACK FOOTER //
// ./src/app/modules/navigation/resources/second-level/settings.js